var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelchairHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29387",
    "data-name": "Group 29387",
    transform: "translate(-355 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(355 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_15_",
    "data-name": "svgexport-17 (15)",
    transform: "translate(373 269.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50094",
    "data-name": "Path 50094",
    d: "M368.868,368.475h.523v2.18h-.523Z",
    transform: "translate(-356.5 -355.815)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_439",
    "data-name": "Ellipse 439",
    cx: 1.409,
    cy: 1.409,
    rx: 1.409,
    ry: 1.409,
    transform: "translate(11.221 14.513)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_440",
    "data-name": "Ellipse 440",
    cx: 0.44,
    cy: 0.44,
    rx: 0.44,
    ry: 0.44,
    transform: "translate(12.189 15.481)",
    fill: "#524798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50095",
    "data-name": "Path 50095",
    d: "M421.3,405.229h-1.728a.349.349,0,0,1-.315-.2l-.507-1.069h2.55a.349.349,0,0,1,.349.349v.571A.349.349,0,0,1,421.3,405.229Z",
    transform: "translate(-404.672 -390.082)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50096",
    "data-name": "Path 50096",
    d: "M45.424,13.879l-.755-1.591a.262.262,0,0,0-.236-.149h-1.3v.523h1.136l.578,1.218ZM33.752,1h-.523V.966a.443.443,0,0,0-.443-.443H31.542V0h1.244a.967.967,0,0,1,.966.966Z",
    transform: "translate(-30.763 0)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50097",
    "data-name": "Path 50097",
    d: "M10.007.209V1.975a.209.209,0,0,1-.209.209H9.089a.209.209,0,0,1-.209-.209V.209A.209.209,0,0,1,9.089,0H9.8a.209.209,0,0,1,.209.209Z",
    transform: "translate(-8.88 0)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50098",
    "data-name": "Path 50098",
    d: "M90.715,229.881H80.638V224.95h9.017a1.409,1.409,0,0,1,1.409,1.409v3.174A.349.349,0,0,1,90.715,229.881Z",
    transform: "translate(-78.173 -217.221)",
    fill: "#df75a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50099",
    "data-name": "Path 50099",
    d: "M85.972,224.95H80.638v3.055a3.1,3.1,0,0,1,5.565,1.876H88.81A5.709,5.709,0,0,0,85.972,224.95Z",
    transform: "translate(-78.173 -217.221)",
    fill: "#dd5790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50100",
    "data-name": "Path 50100",
    d: "M82.751,34.878H80.638V28.115h.4a1.409,1.409,0,0,1,1.407,1.328Z",
    transform: "translate(-78.173 -27.149)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50101",
    "data-name": "Path 50101",
    d: "M94.655,29.47a1.409,1.409,0,0,0-1.368-1.327,1.407,1.407,0,0,1,.663,1.116l.311,5.646h.7Z",
    transform: "translate(-90.387 -27.176)",
    fill: "#b7c8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50102",
    "data-name": "Path 50102",
    d: "M40.033,252.492H37.216a.262.262,0,0,1,0-.523h2.818a.262.262,0,0,1,0,.523Zm-3.874-1.057a.261.261,0,0,1-.261-.262v-2.818a.261.261,0,0,1,.523,0v2.818A.261.261,0,0,1,36.159,251.435Zm0,4.931a.261.261,0,0,1-.261-.262v-2.818a.262.262,0,1,1,.523,0V256.1A.261.261,0,0,1,36.159,256.366Zm-.747-4.622a.261.261,0,0,1-.185-.077l-1.992-1.992a.262.262,0,1,1,.37-.37L35.6,251.3a.261.261,0,0,1-.185.446Zm3.487,3.487a.26.26,0,0,1-.185-.077l-1.992-1.992a.262.262,0,1,1,.37-.37l1.992,1.992a.261.261,0,0,1-.185.446Zm-3.8-2.74H32.285a.262.262,0,1,1,0-.523H35.1a.262.262,0,1,1,0,.523Zm-1.683,2.74a.261.261,0,0,1-.185-.446l1.992-1.992a.262.262,0,1,1,.37.37L33.6,255.154A.261.261,0,0,1,33.419,255.231Zm3.487-3.487a.261.261,0,0,1-.185-.446l1.992-1.992a.262.262,0,1,1,.37.37l-1.992,1.992a.261.261,0,0,1-.185.077Z",
    transform: "translate(-31.228 -239.57)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50103",
    "data-name": "Path 50103",
    d: "M13.811,224.95a4.931,4.931,0,1,0,4.931,4.931A4.931,4.931,0,0,0,13.811,224.95Zm0,8.806a3.874,3.874,0,1,1,3.874-3.874A3.874,3.874,0,0,1,13.811,233.756Z",
    transform: "translate(-8.88 -217.221)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50104",
    "data-name": "Path 50104",
    d: "M45.61,254.763a4.939,4.939,0,0,1,.841,4.344,3.876,3.876,0,0,1-3.412,3.412,4.939,4.939,0,0,1-4.344-.841,4.931,4.931,0,1,0,6.915-6.915Z",
    transform: "translate(-37.671 -246.01)",
    fill: "#524798"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_441",
    "data-name": "Ellipse 441",
    cx: 1.057,
    cy: 1.057,
    rx: 1.057,
    ry: 1.057,
    transform: "translate(3.874 11.603)",
    fill: "#d8e2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50105",
    "data-name": "Path 50105",
    d: "M125.773,340.444a1.057,1.057,0,0,1-1.4,1.4,1.057,1.057,0,1,0,1.4-1.4Z",
    transform: "translate(-120.407 -328.747)",
    fill: "#b7c8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50106",
    "data-name": "Path 50106",
    d: "M135.486,160.465h-5.635v-.423a.7.7,0,0,1,.7-.7h4.227a.7.7,0,0,1,.7.7v.423Z",
    transform: "translate(-125.695 -153.864)",
    fill: "#5e54ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50107",
    "data-name": "Path 50107",
    d: "M80.638,184.532H88.6a.261.261,0,0,1,.261.262v1.127h-.523v-.866h-7.7Z",
    transform: "translate(-78.173 -178.192)",
    fill: "#d8e2f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairHighlighted);
export default __webpack_public_path__ + "static/media/WheelchairHighlighted.e188b401da42db0b1768dd4aa51cdc0e.svg";
export { ForwardRef as ReactComponent };